export default class EstadoDeCuentaModel {
  image: string;
  title: string;
}
